<ea-dropdown-nav-item
	#dropdownContentNav
	[showArrow]="true"
	tooltipText="Your Account"
	faIconClass="user"
	[dropdownId]="constants.dropdownIds.profileActions"
>
	<ng-template #dropdownContent>
		<ul class="profile-action-menu">
			@if (isAdmin && showProfile) {
				<li>
					<ea-button-link
						name="changePassword"
						(onClick)="navigateToChangePassword()"
						data-cy="change-password-link"
						>Change Password</ea-button-link
					>
				</li>
			}
			@if (showProfile) {
				<li>
					<ea-button-link
						name="profile"
						(onClick)="navigateToProfile()"
						data-cy="profile-link"
						>Profile</ea-button-link
					>
				</li>
			}
			<li>
				<ea-logout (keydown)="handleDropdownOnKeydown()"></ea-logout>
			</li>
		</ul>
	</ng-template>
</ea-dropdown-nav-item>
